import { DateTime } from 'luxon';

export default function isPastDate(value: string) {
  if (DateTime.fromISO(value) > DateTime.now()) return 'Date should be in the past';
  return undefined;
}
